{
  "back_to_home": "Back to home",
  "cabins": "Cabins",
  "departure_date": "Departure date",
  "payment": "Payment",
  "personal_information": "Personal information",
  "price_overview": "Price overview & extras",
  "ship": "Ship"
}
